import type { EventCategory, EventType } from "@/services";

/**
 * 이벤트 유형·구분의 한글 표기.
 *
 * 목록(전국·현장)과 상세 모달이 **같은 사건을 다른 이름으로 부르면 안 되므로** 한곳에 둔다.
 * 예전에는 `NationalEventList` 와 `SiteEventList` 가 각자 같은 표를 들고 있었다.
 *
 * 서버가 새 유형을 추가해도 화면이 깨지지 않도록, 모르는 값은 원문을 그대로 보여준다
 * (`EventType` 이 `string & {}` 을 포함하는 이유와 같다).
 */
const TYPE_LABELS: Record<string, string> = {
  NO_HELMET: "안전모",
  FIRE: "화재",
  INTRUSION: "침입",
  GAS_THRESHOLD_EXCEEDED: "가스",
  BAND_VITAL_ABNORMAL: "생체신호",
  HEAT_INDEX_EXCEEDED: "체감온도",
};

const CATEGORY_LABELS: Record<string, string> = {
  DETECTION: "영상 감지",
  SAFETY: "안전 센서",
};

export function typeLabel(type: EventType): string {
  return TYPE_LABELS[type] ?? type;
}

export function categoryLabel(category: EventCategory): string {
  return CATEGORY_LABELS[category] ?? category;
}
